module.exports = __webpack_public_path__ + "static/q3answer2_beachhouse_wishmas-9dce707d3075600555c4232146bd2f20.jpg";